<template>
  <vs-popup :active.sync="isActive" id="qrReaderPage">
    <vs-row vs-type="flex" vs-w="12">
      <vs-col vs-type="flex" vs-w="5" class="p-2">
        <div class="w-full text-center img-border p-5">
          <img @click="focusInput" src="@/assets/general/qr-code-scan.svg" class="w-full">
        </div>
      </vs-col>
      <vs-col vs-type="flex" vs-w="7" class="p-2">
        <vs-row vs-type="flex" vs-="12">
          <vs-row vs-type="flex" vs-w="12">
            <span class="text-medium text-dark weight-600">
              Qr Kodu Tarayabilirsiniz
            </span>
          </vs-row>
          <vs-row v-if="isWallet" vs-type="flex" vs-w="12">
            <span class="text-medium text-dark weight-600">
              Kalan tutar {{ amount }} TL
            </span>
          </vs-row>
          <vs-row vs-type="flex" vs-w="12">
            <span class="text-xsmall text-secondary weight-500">
              Qr Kod doğru şekilde taratıldıktan sonra ekran kendini kapatacaktır.
            </span>
          </vs-row>
          <vs-row vs-type="flex" vs-w="12">
            <span class="text-smaller text-dark weight-600">
              Taramak yapmak yerine 10 haneli Kod ile de müşteriyi tanımlayabilirsiniz.
            </span>
          </vs-row>
          <vs-row vs-type="flex" vs-w="12">
            <input autocomplete="off" id="qrCode" name="Qr Kod" ref="qrInput" placeholder="Qr Kod"
              class="w-full text-dark weight-600 text-small border-all border-grey low-border-radius px-2" v-model="qrCode" />
            <span class="text-danger text-xsmaller"
              v-show="errors.has('Qr Kod')">{{ errors.first("Qr Kod") }}</span>
          </vs-row>
        </vs-row>
      </vs-col>
    </vs-row>
  </vs-popup>
</template>

<script>
  import {
    GetCustomerByQr
  } from "@/api/Campaign.js"
  import {
    ReduceFromWallet
} from "@/api/SelfService";
  export default {
    data() {
      return {
        isActive: false,
        qrCode: "",
        customer: null,
        isWallet : false,
        amount : 0,
        isDiscount : null
      }
    },
    methods: {
      initValues() {
        this.qrCode = "";
        this.customer = null;
      },
      focusInput() {
        this.$nextTick(() => {
          this.$refs.qrInput.focus()
        })
      },
      GetCustomerByQr() {
        GetCustomerByQr(this.qrCode.toUpperCase()).then(res => {
          if (res && res.status == 200 && res.data != null) {
            this.customer = res.data;
            this.customer.giftQrCode = this.qrCode;
            this.isActive = false;
            this.$emit("success", this.customer);
          } else {
            this.customer = null;
            this.qrCode = null;
            this.$fire({
              title: "Bulunamadı ! ",
              text: "Kayıtlı Müşteri Bulunamadı !",
              type: "error"
            });
            this.$vs.notify({
              color: "danger",
              title: "Bulunamadı ! ",
              text: "Kayıtlı Müşteri Bulunamadı !"
            });
          }
        }).catch(() => {
          this.customer = null;
          this.qrCode = null;
          this.$fire({
              title: "Bulunamadı ! ",
              text: "Sunucu Bağlantı Hatası !",
              type: "error"
            });
          this.$vs.notify({
            color: "danger",
            title: "Hata !",
            text: "Sunucu Bağlantı Hatası !"
          });
        });
      },
      reduceFromWallet(val,amount){
        ReduceFromWallet(val,amount).then(res=>{
          this.customer = res.data;
            this.customer.giftQrCode = this.qrCode;
            this.$emit("success", this.customer);
            this.isActive = false;
              debugger;
              console.log(this.customer);

              this.$emit("reduceSuccess", amount, this.isDiscount);
  })
  .catch(err =>{
    this.$fire({
              title: "Hata ! ",
              text: err.response.data.Errors[0].Message,
              type: "error"
            });
          this.$vs.notify({
            color: "danger",
            title: "Hata !",
            text: err.response.data.Errors[0].Message
          });
  })
      }
    },
    watch: {
      isActive(val) {
        if (!val) this.initValues();
        else {
          this.focusInput()
        }
      },
      qrCode(val) {
        if (val && val.length == 10 && /^[Cc][UuAa]\d+$/.test(val)){
          if (this.isWallet) {
            this.reduceFromWallet(val , this.amount);
          }else{
            this.GetCustomerByQr();
          }

        }
      }
    }
  }

</script>

<style>
  #qrReaderPage .vs-popup--header {
    background: none !important;
  }

  #qrReaderPage .vs-popup--header .vs-popup--title h3 {
    display: none;
  }
  .swal2-container {
  z-index: 99999;
}
</style>
